var map = {
	"./100.svg": 13512,
	"./404_1.svg": 94490,
	"./404_2.svg": 9394,
	"./android.svg": 2120,
	"./baidu.svg": 5370,
	"./bili.svg": 17580,
	"./bozhu.svg": 3222,
	"./chat.svg": 80948,
	"./chrome.svg": 86626,
	"./copyright.svg": 67841,
	"./csdn.svg": 29680,
	"./deep.svg": 92782,
	"./dianzan.svg": 52881,
	"./edge.svg": 65151,
	"./email.svg": 6764,
	"./emoji1.svg": 52284,
	"./emoji2.svg": 76925,
	"./gitee.svg": 6094,
	"./github.svg": 79953,
	"./google.svg": 54381,
	"./guanfang.svg": 31911,
	"./guanzhume.svg": 60334,
	"./hot.svg": 38831,
	"./link.svg": 26248,
	"./mac.svg": 52283,
	"./notice.svg": 80443,
	"./photo.svg": 79685,
	"./qq.svg": 56123,
	"./qqgroup.svg": 40915,
	"./safari.svg": 61743,
	"./shallow.svg": 28238,
	"./shandian.svg": 21874,
	"./sxdianzan.svg": 2899,
	"./tag.svg": 66247,
	"./topBar.svg": 64519,
	"./tuijian.svg": 69063,
	"./wechat.svg": 17256,
	"./weibo.svg": 32036,
	"./windowns.svg": 98413,
	"./xkxy.svg": 99464,
	"./xuhao.svg": 80490,
	"./yuan.svg": 22791,
	"./yuanchuang.svg": 95676,
	"./zhihu.svg": 28513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;